export const colorPalette = {
    red: "#DF4B44",
    blue: "#2A70E9",
  };